<define/FacebookIcon>
  <svg
    width="31"
    height="31"
    viewBox="0 0 32 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Facebook</title>
    <path
      d="M31.1914 15.2724C31.1914 22.9674 25.4877 29.3291 18.078 30.3614C17.3852 30.4575 16.6764 30.5077 15.9569 30.5077C15.1264 30.5077 14.3108 30.4415 13.5165 30.3134C6.26277 29.1454 0.722351 22.8553 0.722351 15.2724C0.722351 6.85787 7.54379 0.0361328 15.958 0.0361328C24.3721 0.0361328 31.1936 6.85787 31.1936 15.2724H31.1914Z"
      fill="#AE284C"
    />
    <path
      d="M18.0781 12.2706V15.5896H22.1837L21.5336 20.0606H18.0781V30.3615C17.3852 30.4576 16.6764 30.5078 15.9569 30.5078C15.1264 30.5078 14.3108 30.4416 13.5166 30.3135V20.0606H9.73007V15.5896H13.5166V11.5286C13.5166 9.00915 15.5587 6.96582 18.0791 6.96582V6.96796C18.0866 6.96796 18.093 6.96582 18.1005 6.96582H22.1848V10.8325H19.516C18.7228 10.8325 18.0791 11.4763 18.0791 12.2695L18.0781 12.2706Z"
      fill="#FCF3D4"
    />
  </svg>
</define>

<define/InstagramIcon>
  <svg
    width="31"
    height="31"
    viewBox="0 0 31 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Instagram</title>
    <path
      d="M15.4639 0.0361328H15.3945C6.99925 0.0361328 0.193573 6.84188 0.193573 15.2372V15.3066C0.193573 23.7019 6.99925 30.5077 15.3945 30.5077H15.4639C23.8591 30.5077 30.6648 23.7019 30.6648 15.3066V15.2372C30.6648 6.84188 23.8591 0.0361328 15.4639 0.0361328Z"
      fill="#AE284C"
    />
    <path
      d="M20.1441 6.23535H10.7154C8.11058 6.23535 5.99149 8.35447 5.99149 10.9593V19.5853C5.99149 22.1901 8.11058 24.3092 10.7154 24.3092H20.1441C22.7489 24.3092 24.868 22.1901 24.868 19.5853V10.9593C24.868 8.35447 22.7489 6.23535 20.1441 6.23535ZM7.65794 10.9593C7.65794 9.27364 9.02975 7.90182 10.7154 7.90182H20.1441C21.8297 7.90182 23.2015 9.27364 23.2015 10.9593V19.5853C23.2015 21.2709 21.8297 22.6428 20.1441 22.6428H10.7154C9.02975 22.6428 7.65794 21.2709 7.65794 19.5853V10.9593Z"
      fill="#FCF3D4"
    />
    <path
      d="M15.4297 19.6654C17.852 19.6654 19.8238 17.6947 19.8238 15.2713C19.8238 12.8479 17.8531 10.8772 15.4297 10.8772C13.0064 10.8772 11.0357 12.8479 11.0357 15.2713C11.0357 17.6947 13.0064 19.6654 15.4297 19.6654ZM15.4297 12.5447C16.9339 12.5447 18.1573 13.7682 18.1573 15.2724C18.1573 16.7766 16.9339 18 15.4297 18C13.9255 18 12.7021 16.7766 12.7021 15.2724C12.7021 13.7682 13.9255 12.5447 15.4297 12.5447Z"
      fill="#FCF3D4"
    />
    <path
      d="M20.2305 11.5873C20.8828 11.5873 21.4144 11.0568 21.4144 10.4034C21.4144 9.75007 20.8839 9.21948 20.2305 9.21948C19.5772 9.21948 19.0466 9.75007 19.0466 10.4034C19.0466 11.0568 19.5772 11.5873 20.2305 11.5873Z"
      fill="#FCF3D4"
    />
  </svg>
</define>

<div class="flex gap-2">
  <social-icon url="https://www.facebook.com/cubaconmigo" label="Facebook">
    <FacebookIcon/>
  </social-icon>
  <social-icon url="https://www.instagram.com/cuba_conmigo" label="Instagram">
    <InstagramIcon/>
  </social-icon>
</div>
